const { getElements } = window.BAO.Utils

class MobileProductTabs extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    const hasActiveTab = this.tabs.some(
      (tabEl) => tabEl.getAttribute('aria-current') === 'true',
    )

    if (!hasActiveTab && this.panels[0]) {
      this.activate(this.panels[0].dataset.mobileTabPanel)
    }
  }

  setupListeners () {
    super.setupListeners()

    this.handleClick = this.handleClick.bind(this)

    this.listeners.add(document, 'click', this.handleClick)
  }

  handleClick (event) {
    const clickedTabEl = event.target.closest('[data-mobile-tab]')

    if (!clickedTabEl) return

    this.activate(clickedTabEl.dataset.mobileTab)
  }

  activate (value) {
    this.panels.forEach((panelEl) => {
      panelEl.setAttribute(
        'aria-hidden',
        panelEl.dataset.mobileTabPanel !== value,
      )
    })

    this.tabs.forEach((tabEl) => {
      tabEl.setAttribute('aria-current', tabEl.dataset.mobileTab === value)
    })
  }

  get tabs () {
    return getElements('[data-mobile-tab]')
  }

  get panels () {
    return this.els.panel?.elements || []
  }
}

if (!customElements.get('mobile-product-tabs')) {
  customElements.define('mobile-product-tabs', MobileProductTabs)
}
